import videoTabInactive from "../../../assets/images/videoimage.png";
import videoTabActive from "../../../assets/images/activeTabImage.png";
import loginUser from "../../../assets/images/userImg.png";
import sidebarLogo from "../../../assets/images/logo.png";
import sidebarSmallLogo from "../../../assets/images/logo-small.png";
import bloodPressure from "../../../assets/images/bloodpressure.png";
import ecgImage from "../../../assets/images/ecgImage.png";
import weightImg from "../../../assets/images/weight.png";

export default {
  videoTabInactive,
  videoTabActive,
  loginUser,
  sidebarLogo,
  sidebarSmallLogo,
  bloodPressure,
  ecgImage,
  weightImg,
};
